// components/SuccessScreen.js
import { Box, Typography, Button } from "@mui/material";
import Logo from "../assets/logo.png";

export default function SuccessScreen({
  message = "Thank you for signing with OceanLogix.",
  title = "Document signed successfully ✅",
  onClick,
  fullHeight = true,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={fullHeight ? "100vh" : "auto"}
      width="100%"
      textAlign="center"
      px={2}
      gap={3}
      sx={{
        background: "linear-gradient(to bottom right, #7AB2D3, #b3e5fc)",
      }}
    >
      <Box mb={2}>
        <img src={Logo} alt="OceanLogix" style={{ width: 160 }} />
      </Box>

      <Typography
        variant="h4"
        color="common.white"
        fontWeight="bold"
        gutterBottom
      >
        {title}
      </Typography>

      <Typography variant="body1" color="common.white" sx={{ maxWidth: 400 }}>
        {message}
      </Typography>

      {onClick && (
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3, px: 4, py: 1.2, fontWeight: 600 }}
          onClick={onClick}
        >
          Go Back Home
        </Button>
      )}
    </Box>
  );
}
